import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PersonModel } from '@bayclubs/court-booking-employee-api';

@Component({
    selector: 'app-court-booking-player-info',
    templateUrl: './court-booking-player-info.component.html',
    styleUrls: ['./court-booking-player-info.component.scss'],
    standalone: false
})
export class CourtBookingPlayerInfoComponent implements OnInit {
    @Input() person: PersonModel;
    @Input() showRemoveButton: boolean;
    @Output() removePerson: EventEmitter<PersonModel> = new EventEmitter();
    constructor() { }

    ngOnInit(): void { }

    get userName(): string {
        return `${this.person.firstName} ${this.person.lastName}`;
    }

    get isGuest(): boolean {
        return this.person.personId === null;
    }

    onRemoveClick() {
        this.removePerson.emit(this.person);
    }
}
